import { TeamDataObject } from "../DataStorage/TeamDataObject";
import { BuilderProjectType } from "./BuilderProjectType";
import { DataUtilities } from "../../Common/DataUtilities";

export class BuilderProjectData extends TeamDataObject {
    name: string;
    projectId: string = DataUtilities.generateUniqueId();
    path: string = "/builderProjects";
    projectType: BuilderProjectType = BuilderProjectType.BUILDER_PROJECT;

    builderCount: BuilderCountData[] = [];

    constructor(name: string) {
        super();
        this.name = name;
    }
}

export class BuilderCountData {
    changeSetName: string = "";
    count: number = 0;
}
